import React from "react";
// import _ from 'lodash'
// import MultiLineText from './MultiLineText';
import BG from "./7.png";

export default ({ currentLang, selectedType }) => {
  const shouldDisplayByLang = selectLang => {
    return currentLang === selectLang ? "display" : "display-none";
  };
  const shouldDisplayByType = type => {
    return selectedType === type || selectedType === "all"
      ? "opacity-in"
      : "opacity-out";
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 329.4 363.4"
      className="site-plan-svg"
    >
      <g id="map">
        <image xlinkHref={BG} height="100%" width="100%" />
      </g>
      <g xmlns="http://www.w3.org/2000/svg" id="floorplan">
        <g id="studio" className={shouldDisplayByType("studio")}>
          <polygon
            id="_1A_2706"
            data-name="1A_2706"
            points="72.6 133.2 99.7 133.2 99.7 148 94.5 148 94.5 159.4 72.6 159.4 72.6 133.2"
            fill="#231f20"
          />
          <polygon
            id="_1A_2705"
            data-name="1A_2705"
            points="109 97.7 133.6 97.7 133.6 124.7 119.5 124.7 119.5 119.6 108.8 119.6 109 97.7"
            fill="#231f20"
          />
        </g>
        <g id="one-bedroom" className={shouldDisplayByType("one-bedroom")}>
          <polygon
            id="_1Cx_2718"
            data-name="1Cx_2718"
            points="212.9 54 227.9 54 227.9 58.4 239.2 58.4 239.2 90.5 212.8 90.5 212.9 54"
            fill="#231f20"
          />
          <polygon
            id="_1Cx_2717"
            data-name="1Cx_2717"
            points="186.7 54 201.6 54 201.6 58.5 212.7 58.5 212.7 90.5 186.7 90.5 186.7 54"
            fill="#231f20"
          />
          <polygon
            id="_1Cx_2712"
            data-name="1Cx_2712"
            points="33.6 211.8 65.5 211.8 65.5 237.8 29.3 237.8 29.3 223.1 33.6 223.1 33.6 211.8"
            fill="#231f20"
          />
          <polygon
            id="_1Cx_2711"
            data-name="1Cx_2711"
            points="65.5 264.2 29.2 264.2 29.2 249.3 33.6 249.3 33.6 237.9 65.5 237.9 65.5 264.2"
            fill="#231f20"
          />
        </g>
        <g id="two-bedroom" className={shouldDisplayByType("two-bedroom")}>
          <polygon
            id="_2Ax2_2710"
            data-name="2Ax2_2710"
            points="72.5 277.8 94.5 277.8 94.5 289.6 99.7 289.6 99.7 317.3 72.6 317.3 72.5 277.8"
            fill="#231f20"
          />
          <polygon
            id="_2Bx1_2709"
            data-name="2Bx1_2709"
            points="72.6 238 99.8 238 99.8 250.4 104.5 250.4 104.5 277.8 72.5 277.8 72.6 238"
            fill="#231f20"
          />
          <polygon
            id="_2Cx2_2708"
            data-name="2Cx2_2708"
            points="72.6 198.7 104.5 198.7 104.6 211.1 109.3 211.1 109.3 238 72.6 238 72.6 198.7"
            fill="#231f20"
          />
          <rect
            id="_2B1_2707"
            data-name="2B1_2707"
            x="72.6"
            y="159.4"
            width="27.1"
            height="39.13"
            fill="#231f20"
          />
          <polygon
            id="_2Cx2_2704"
            data-name="2Cx2_2704"
            points="134.4 97.7 173.1 97.7 173.1 129.6 161.2 129.6 161.2 134.4 133.8 134.4 133.8 97.7 134.4 97.7"
            fill="#231f20"
          />
          <polygon
            id="_2Bx1_2703"
            data-name="2Bx1_2703"
            points="212.9 97.7 213 124.6 200.5 124.6 200.5 129.6 173.1 129.6 173.1 97.7 212.9 97.7"
            fill="#231f20"
          />
          <polygon
            id="_2Bx2_2702"
            data-name="2Bx2_2702"
            points="252.2 97.7 252.2 124.8 239.8 124.8 239.8 129.6 212.9 129.6 212.9 97.7 252.2 97.7"
            fill="#231f20"
          />
          <polygon
            id="_2C1_2701"
            data-name="2C1_2701"
            points="291 97.7 290.8 129.6 252.2 129.6 252.2 97.7 291 97.7"
            fill="#231f20"
          />
          <polygon
            id="_2Cx1_2716"
            data-name="2Cx1_2716"
            points="147.4 53.9 174.3 53.9 174.3 58.6 186.6 58.6 186.6 90.5 147.4 90.5 147.4 53.9"
            fill="#231f20"
          />
          <polygon
            id="_2Bx2_2715"
            data-name="2Bx2_2715"
            points="108.3 58.5 135.1 58.5 135.1 63.4 147.3 63.4 147.3 90.5 108.1 90.5 108.3 58.5"
            fill="#231f20"
          />
          <polygon
            id="_2C1_2714"
            data-name="2C1_2714"
            points="33.6 133.9 65.5 133.9 65.5 172.5 33.6 172.5 33.6 133.9"
            fill="#231f20"
          />
          <polygon
            id="_2Cx2_2713"
            data-name="2Cx2_2713"
            points="28.8 184.9 33.6 184.9 33.6 172.5 65.5 172.5 65.5 211.8 28.8 211.8 28.8 184.9"
            fill="#231f20"
          />
        </g>
      </g>
      <g xmlns="http://www.w3.org/2000/svg" id="text">
        <g id="cn" className={shouldDisplayByLang("cn")}>
          <text
            transform="translate(266.7 141.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2701
          </text>
          <text
            transform="translate(227 141.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2702
          </text>
          <text
            transform="translate(188.9 141.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2703
          </text>
          <text
            transform="translate(147.6 141.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2704
          </text>
          <text
            transform="translate(118.3 133.5)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2705
          </text>
          <text
            transform="translate(105.3 149.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2706
          </text>
          <text
            transform="translate(114.3 175.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2707
          </text>
          <text
            transform="translate(114.3 218.1)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2708
          </text>
          <text
            transform="translate(114.3 259.1)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2709
          </text>
          <text
            transform="translate(114.3 299.4)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2710
          </text>
          <text
            transform="translate(123.4 48.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2715
          </text>
          <text
            transform="translate(162.6 48.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2716
          </text>
          <text
            transform="translate(194.1 48.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2717
          </text>
          <text
            transform="translate(220 48.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2718
          </text>
          <text
            transform="translate(14.2 156.3)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2714
          </text>
          <text
            transform="translate(14.2 194.4)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2713
          </text>
          <text
            transform="translate(14.2 227.2)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2712
          </text>
          <text
            transform="translate(14.2 253.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2711
          </text>
          <text
            transform="translate(189 214.9)"
            font-size="10"
            fill="#58595b"
            font-family="Termina-Bold, Termina Bold"
          >
            <tspan font-weight="700">7</tspan>
            <tspan
              x="5.1"
              y="0"
              font-family="STHeitiTC-Medium, STHeitiTC Medium"
            >
              楼
            </tspan>
          </text>
        </g>
        <g id="ru" className={shouldDisplayByLang("ru")}>
          <text
            transform="translate(266.7 141.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2701
          </text>
          <text
            transform="translate(227 141.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2702
          </text>
          <text
            transform="translate(188.9 141.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2703
          </text>
          <text
            transform="translate(147.6 141.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2704
          </text>
          <text
            transform="translate(118.3 133.5)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2705
          </text>
          <text
            transform="translate(105.3 149.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2706
          </text>
          <text
            transform="translate(114.3 175.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2707
          </text>
          <text
            transform="translate(114.3 218.1)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2708
          </text>
          <text
            transform="translate(114.3 259.1)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2709
          </text>
          <text
            transform="translate(114.3 299.4)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2710
          </text>
          <text
            transform="translate(123.4 49)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2715
          </text>
          <text
            transform="translate(162.6 49)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2716
          </text>
          <text
            transform="translate(194.1 49)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2717
          </text>
          <text
            transform="translate(220 49)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2718
          </text>
          <text
            transform="translate(14.2 156.3)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2714
          </text>
          <text
            transform="translate(14.2 194.4)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2713
          </text>
          <text
            transform="translate(14.2 227.2)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2712
          </text>
          <text
            transform="translate(14.2 253.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2711
          </text>
          <text
            transform="translate(181.2 214.9)"
            font-size="11"
            fill="#58595b"
            font-family="Helvetica-Bold, Helvetica"
            font-weight="700"
          >
            7-Й ЭТАЖ
          </text>
        </g>
        <g id="en" className={shouldDisplayByLang("en")}>
          <text
            transform="translate(266.7 141.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2701
          </text>
          <text
            transform="translate(227 141.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2702
          </text>
          <text
            transform="translate(188.9 141.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2703
          </text>
          <text
            transform="translate(147.6 141.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2704
          </text>
          <text
            transform="translate(118.3 133.5)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2705
          </text>
          <text
            transform="translate(105.3 149.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2706
          </text>
          <text
            transform="translate(114.3 175.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2707
          </text>
          <text
            transform="translate(114.3 218.1)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2708
          </text>
          <text
            transform="translate(114.3 259.1)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2709
          </text>
          <text
            transform="translate(114.3 299.4)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2710
          </text>
          <text
            transform="translate(123.4 48.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2715
          </text>
          <text
            transform="translate(162.6 48.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2716
          </text>
          <text
            transform="translate(194.1 48.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2717
          </text>
          <text
            transform="translate(220 48.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2718
          </text>
          <text
            transform="translate(14.2 156.3)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2714
          </text>
          <text
            transform="translate(14.2 194.4)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2713
          </text>
          <text
            transform="translate(14.2 227.2)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2712
          </text>
          <text
            transform="translate(14.2 253.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2711
          </text>
          <text
            transform="translate(177.9 214.9)"
            font-size="10"
            fill="#58595b"
            font-family="Termina-Bold, Termina Bold"
            font-weight="700"
          >
            7th Floor
          </text>
        </g>
      </g>
    </svg>
  );
};



// WEBPACK FOOTER //
// ./src/data/PhuketSkypark/sitePlan/svg/b/7.js